import ClassNames from "classnames";
import { FunctionComponent } from "react";
import globalTranslations from "../../i18n/index.js";
import { Language } from "../../types/index.js";
import { getTranslations } from "../../utils/utils.js";

interface Props {
  className: string;
  isMenuOpen: boolean;
  languageId: Language;
  onClick: () => void;
}

const HamburgerButton: FunctionComponent<Props> = ({
  className,
  isMenuOpen,
  languageId,
  onClick,
}) => {
  const i18n = getTranslations(languageId, globalTranslations);

  return (
    <button
      type="button"
      className={ClassNames("HamburgerButton", className, {
        "HamburgerButton--open": isMenuOpen,
      })}
      onClick={onClick}
      aria-label={isMenuOpen ? i18n.menu.close : i18n.menu.open}
    >
      <span className="HamburgerButton__Icon">
        <span className="HamburgerButton__Line HamburgerButton__Line1"></span>
        <span className="HamburgerButton__Line HamburgerButton__Line2"></span>
        <span className="HamburgerButton__Line HamburgerButton__Line3"></span>
      </span>
    </button>
  );
};

export default HamburgerButton;
